<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fm-title" id="fm-2">ABBREVIATIONS</h1>
<table class="table">
<tbody>
<tr>
<td class="w25"><p class="t-left">CSCO</p></td>
<td class="w70"><p class="t-left">Corpus Scriptorum Christianorum Orientalium. Leuven: Peeters, 1903–.</p></td>
</tr>
<tr>
<td class="w25"><p class="t-left"><em>GEDSH</em></p></td>
<td class="w70"><p class="t-left"><em>The Gorgias Encyclopedic Dictionary of the Syriac Heritage</em>. Edited by Sebastian P. Brock, Aaron M. Butts, George A. Kiraz, and Lucas Van Rompay. Piscataway, NJ: Gorgias, 2011 (online at <a href="http://gedsh.bethmardutho.org" target="_blank">http://gedsh.bethmardutho.org</a>).</p></td>
</tr>
<tr>
<td class="w25"><p class="t-left">LXX</p></td>
<td class="w70"><p class="t-left">Septuagint</p></td>
</tr>
<tr>
<td class="w25"><p class="t-left"><em>MH</em></p></td>
<td class="w70"><p class="t-left"><em>Matenagirk‘ Hayoc‘</em> (<em>Armenian Classical Authors</em>). Vols. 1–15: Antelias, Lebanon, 2003–2010; vols. 16–21: Erevan, Armenia, 2012– (some volumes online at <a href="https://matenadaran.am" target="_blank">https://matenadaran.am</a>).</p></td>
</tr>
<tr>
<td class="w25"><p class="t-left">RIÉ</p></td>
<td class="w70"><p class="t-left"><em>Recueil des inscriptions de l’Éthiopie des périodes pré-axoumite et axoumite</em>. Vol. 1, <em>Les document</em>s, and Vol. 2, <em>Les planches</em>, by É. Bernand, A. J. Drewes, and R. Schneider. Paris: Boccard, 1991. Vol. 3, <em>Traductions et commentaires</em>, part A, <em>Les inscriptions grecques</em>, by É. Bernand. Paris: Boccard, 2000. Vol. 3, <em>Traductions et commentaires</em>, part B, <em>Les inscriptions sémitiques</em>, by A. J. Drewes, revised by Manfred Kropp, edited by Manfred Kropp and Harry Stroomer. Äthiopistische Forschungen 85/De Goeje Fund 34; Wiesbaden: Harrassowitz, 2019.</p></td>
</tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 007_Abbreviations.vue?f4e46612